import { Component, Input, OnInit, ViewEncapsulation } from "@angular/core";

@Component({
    selector: "pme-alert",
    templateUrl: "./alert.component.html",
    styleUrls: ["./alert.component.scss"],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AlertComponent implements OnInit {
  @Input() type: string;
  @Input() title: string;

  constructor() {}

  ngOnInit() {
  }
}
